export const EVENT_START_ANALYTICS_ENGINE = 'start analytics';
export const SESSION_IDLE_MESSAGE_TYPE = 'session-idle';

export const EVENT_APP_VIEW_TO_MAIN_GET_ANALYTICS_STORE_IS_DEBUG =
  'EVENT_APP_VIEW_TO_MAIN_GET_ANALYTICS_STORE_IS_DEBUG';
export const EVENT_APP_VIEW_TO_MAIN_GET_ANALYTICS_STORE =
  'EVENT_APP_VIEW_TO_MAIN_GET_ANALYTICS_STORE';
export const EVENT_APP_VIEW_TO_MAIN_TEST_ANALYTICS_STORE =
  'EVENT_APP_VIEW_TO_MAIN_TEST_ANALYTICS_STORE';
export const EVENT_APP_VIEW_TO_MAIN_RESET_ANALYTICS_STORE =
  'EVENT_APP_VIEW_TO_MAIN_RESET_ANALYTICS_STORE';
export const EVENT_APP_VIEW_TO_MAIN_SET_ANALYTICS_STORE =
  'EVENT_APP_VIEW_TO_MAIN_SET_ANALYTICS_STORE';
export const EVENT_MAIN_TO_APP_ANALYTICS_SEESION_IDLE =
  'EVENT_MAIN_TO_APP_ANALYTICS_SEESION_IDLE';

export const ANALYTICS_SESSION_TIMEOUT = 45 * 60 * 1000; // analytics session timeout - 45 minutes
export const ANALYTICS_KEEPALIVE_INTERVAL = 15 * 1000; // keepalive interval - 15 seconds
export const ANALYTICS_HEARTBEAT_INTERVAL = 60 * 1000; // keepalive interval - 60 seconds

export const ANALYTICS_TEST_SESSION_TIMEOUT = 105 * 1000; // analytics session timeout - 1:50 minutes
export const ANALYTICS_TEST_KEEPALIVE_INTERVAL = 11000; // keepalive interval miliseconds - 11 seconds
export const ANALYTICS_TEST_HEARTBEAT_INTERVAL = 32000; // keepalive interval miliseconds - 32 seconds

export const ANALYTICS_VISIT_DELAY = 2000;
export const ANALYTICS_DEBOUNCE_TRACK_EVENT = 250;

export const analyticsConfig = {
  analyticsSessionTimeout: ANALYTICS_SESSION_TIMEOUT,
  keepaliveInterval: ANALYTICS_KEEPALIVE_INTERVAL,
  heartbeatInterval: ANALYTICS_HEARTBEAT_INTERVAL,
  visitDelay: ANALYTICS_VISIT_DELAY,
  debounceTrackEvent: ANALYTICS_DEBOUNCE_TRACK_EVENT,
};

export const analyticsTestConfig = {
  analyticsSessionTimeout: ANALYTICS_TEST_SESSION_TIMEOUT,
  keepaliveInterval: ANALYTICS_TEST_KEEPALIVE_INTERVAL,
  heartbeatInterval: ANALYTICS_TEST_HEARTBEAT_INTERVAL,
  visitDelay: ANALYTICS_VISIT_DELAY,
  debounceTrackEvent: ANALYTICS_DEBOUNCE_TRACK_EVENT,
};

export const interactionEvents = [
  'mousedown',
  'keydown',
  'mousemove',
  'touchstart',
  'scroll',
  'resize',
  'focus',
  'blur',
  'visibilitychange',
];
